import hljs from 'highlight.js/lib/core';
import React, { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { Modal, ModalSize } from '@column/column-ui-kit';

import { keysToSnakeCase } from '~/util';

const Code = styled.div`
  padding: 24px 32px;
  border-top: 1px solid ${({ theme }) => theme.secondary.blendToBackground(150)};
  background-color: ${({ theme }) => theme.secondary.blendToBackground(25)};
  border-radius: 0 0 24px 24px;
  margin-top: -1px;
  overflow-y: scroll;
  font-size: 13px;
  line-height: 1.6;
  max-height: min(560px, calc(100dvh - 200px));
  height: 560px;

  pre {
    margin: 0;
    padding: 0;

    code.hljs {
      background: none;
      padding: 0;
      font-family: 'Roboto Mono', monospace;
      white-space: pre-wrap;
      word-break: break-word;
    }
  }
`;

export interface EventDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
}

export const EventDetailModal: FC<EventDetailModalProps> = ({ isOpen, onClose, data }) => {
  const codeRef = useRef<HTMLElement | null>(null);

  const highlightCode = (element: HTMLElement | null) => {
    if (element && isOpen) {
      element.removeAttribute('data-highlighted');
      hljs.highlightElement(element);
    }
  };

  const codeRefCallback = (element: HTMLElement | null) => {
    codeRef.current = element;
    highlightCode(element);
  };

  useEffect(() => {
    highlightCode(codeRef.current);
  }, [data, isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={ModalSize.Medium} withClose={false}>
      <Modal.Header title="Event Details">
        <Modal.Close variant="subtle" size="small" onClick={onClose} />
      </Modal.Header>
      <Code>
        <pre>
          <code ref={codeRefCallback} className="language-json">
            {JSON.stringify(keysToSnakeCase(data), null, 2)}
          </code>
        </pre>
      </Code>
    </Modal>
  );
};
